import React from 'react'

export default class TtlWidget extends React.Component {

  state = {
    value: 0,
  }

  componentDidMount() {
    this.setState({
      value: this.props.ttl,
    })
  }

  onMouseUp(event) {
    this.props.setTtl(this.props.id, event.target.value, (result) => {})
  }

  onChange(event) {
    this.setState({
      value: event.target.value,
    })
  }

  render() {
    return (
      <div>
        <label ref={'label_ttl_' + this.props.id} htmlFor={'range_ttl_' + this.props.id}>{'Jours: ' + this.state.value}</label>
        <input id={'range_ttl_' + this.props.id} type="range" min="0" max="30" step="1" defaultValue={this.props.ttl} onMouseUp={this.onMouseUp.bind(this)} onChange={this.onChange.bind(this)}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/preferences/TtlWidget.js